export class YieldPerReq{
    batchNumber: string
    yieldPer : number
    year:number

    constructor(batchNumber:string,yieldPer:number, year:number){
        this.batchNumber = batchNumber
        this.yieldPer = yieldPer
        this.year = year
    }
}